//Frontend/src/unicodex_ui/services/portalPurchasingApi.js
import api from "./apiClient";

const portalPurchasingApi = {
  async listBranches() {
    // Purchasing depends on branchId; branches are managed in inventory module
    const res = await api.get("/api/inventory/branches");
    return res.data;
  },
  async listSuppliers(params) {
    const res = await api.get("/api/purchasing/suppliers", { params });
    return res.data;
  },
  async createSupplier(payload) {
    const res = await api.post("/api/purchasing/suppliers", payload);
    return res.data;
  },

  async listPurchaseOrders(params) {
    const res = await api.get("/api/purchasing/purchase-orders", { params });
    return res.data;
  },
  async createPurchaseOrder(payload) {
    const res = await api.post("/api/purchasing/purchase-orders", payload);
    return res.data;
  },
  async approvePurchaseOrder(id) {
    const res = await api.post(`/api/purchasing/purchase-orders/${id}/approve`);
    return res.data;
  },
  async markSentPurchaseOrder(id) {
    const res = await api.post(`/api/purchasing/purchase-orders/${id}/mark-sent`);
    return res.data;
  },
  async cancelPurchaseOrder(id) {
    const res = await api.post(`/api/purchasing/purchase-orders/${id}/cancel`);
    return res.data;
  },

  async listGoodsReceipts(params) {
    const res = await api.get("/api/purchasing/goods-receipts", { params });
    return res.data;
  },
  async createGoodsReceipt(payload) {
    const res = await api.post("/api/purchasing/goods-receipts", payload);
    return res.data;
  },
  async postGoodsReceipt(id) {
    const res = await api.post(`/api/purchasing/goods-receipts/${id}/post`);
    return res.data;
  },
};

export default portalPurchasingApi;
